import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { Button, createStyles, makeStyles, Theme, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { baseEndpoint } from "../App";
import { Property } from "../Models/Property";
import React from "react";
import { setClaimProperty } from '../Actions/PropertyActions';

// --- Types & Interfaces ---
interface PropertyClaimPageProps {
    id: string,
}

interface PropertyClaimPageReduxProps {
    userState: any,
    setClaimProperty: (property: Property) => void
}

// --- Styles ---
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            marginTop: "10px",
            display: "flex"
        },
        createButton: {
            backgroundColor: "#17d703",
            border: "none",
            borderRadius: "35px",
            padding: "8px 11px",
            fontWeight: 500,
            cursor: "pointer",
            '&:hover': {
                backgroundColor: "#19ea03",
            }
        },
        headerBar: {
            border: "4px solid #0404fc",
            borderWidth: "5px",
            backgroundColor: "#0404fc",
            textAlign: "left",
            paddingLeft: "10px",
            paddingBottom: "3px",
            height: "24px",
            marginRight: "2%",
            marginLeft: "17px",
            color: "white",
            fontWeight: "bolder"
        },
        messageContainer: {
            width: "55%",
            marginTop: "15px",
            textAlign: "left",
            marginLeft: "5%"
        },
        propertyAddress: {
            backgroundColor: "rgb(217, 217, 255)",
            width: "fit-content",
            padding: "0px 5px"
        },
        claimDescription: {
            marginTop: "15px",
            marginBottom: theme.spacing(2)
        }
    }),
);

function PropertyClaimPage(props: RouteComponentProps<PropertyClaimPageProps> & PropertyClaimPageReduxProps) {
    const classes = useStyles();
    const [property, setProperty] = useState<Property>({} as Property);

    useEffect(() => {
        fetchProperty();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.match.params.id])

    async function fetchProperty() {
        try {
            const response = await fetch(baseEndpoint + 'Properties/address/' + props.match.params.id);
            if (response.ok) {
                const data = await response.json() as Property;
                setProperty(data);
            }
        } catch (ex) {
            console.error('Error fetching property:', ex);
        }
    }

    return (
        <div className={classes.root}>
            <div style={{ width: "100%" }}>
                <div className={classes.headerBar} />
                <div className={classes.messageContainer}>
                    <Typography variant="h4" gutterBottom>
                        Claim Your Property
                    </Typography>
                    <Typography variant="body1" className={classes.claimDescription}>
                        As a landlord, by claiming your property, you can then work with Parslii to verify building
                        information that will increase your Parslii Score, making your property stand out from others,
                        make due diligence and lease negotiation time more efficient, and make the lease process cheaper
                        and quicker. All increasing the chances your retail spaces will get chosen -and rented- faster
                        than other spaces.
                    </Typography>
                    {property.addresses && (
                        <Typography variant="h6" className={classes.propertyAddress}>
                            {property.addresses[0].address + " " + property.addresses[0].city}
                        </Typography>
                    )}
                    <Typography variant="body1" style={{ marginTop: "15px" }}>
                        Create a Parslii 'Landlord Account' and get started claiming your properties!
                    </Typography>
                    <Button
                        className={classes.createButton}
                        onClick={() => {
                            props.setClaimProperty(property);
                            props.history.push('/signup/landlord/subscriptions');
                        }}
                        style={{ marginTop: "15px" }}
                    >
                        Create Account
                    </Button>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state: any) => ({
    userState: state.userState
});

const mapDispatchToProps = (dispatch: any) => ({
    setClaimProperty: (property: Property) => dispatch(setClaimProperty(property))
});

export default connect(mapStateToProps, mapDispatchToProps)(PropertyClaimPage);